import * as R from 'ramda';

export const setTagsMutation = (state, data) => {
    state.tags = data;
    data.forEach(item => {
        state.tagsObject[item.id] = item.name;
    });
};
export const addTagMutation = (state, data) => {
    state.tags.push(data);
    state.tagsObject[data.id] = data.name;
};
export const editTagMutation = (state, data) => {
    const item = state.tags.find(item => item.id === data.id);
    Object.assign(item, data);
};
export const deleteTagMutation = (state, data) => {
    const index = R.findIndex(R.propEq('id', data['id']))(state.tags);
    state.tags.splice(index, 1);
};
export const setServiceOptionsMutation = (state, data) => {
    state.serviceOptions = data;
    data.forEach(item => {
        state.serviceOptionsObject[item.id] = item.name;
    });
};
export const setFacilityOptionsMutation = (state, data) => {
    state.facilityOptions = data;
    data.forEach(item => {
        state.facilityOptionsObject[item.id] = item.name;
    });
};
export const setParkingOptionsMutation = (state, data) => {
    state.parkingOptions = data;
    data.forEach(item => {
        state.parkingOptionsObject[item.id] = item.name;
    });
};
export const setGoodForOptionsMutation = (state, data) => {
    state.goodForOptions = data;
    data.forEach(item => {
        state.goodForOptionsObject[item.id] = item.name;
    });
};
export const setMealOptionsMutation = (state, data) => {
    state.mealOptions = data;
    data.forEach(item => {
        state.mealOptionsObject[item.id] = item.name;
    });
};
export const setFoodOptionsMutation = (state, data) => {
    state.foodOptions = data;
    data.forEach(item => {
        state.foodOptionsObject[item.id] = item.name;
    });
};
